module.exports = __webpack_public_path__ + "videos/animation-video-alexgrigg.87ebb9a.mp4";